<template>
	<div>
		<v-layout row wrap
			justify-end
			align-center
			class="header-booking-data">
			<v-flex xs2 xl-2 lg2 text-xs-right>
				<v-select
					v-bind:items="subsidiaries"
					class="filter-select"
					item-text="name"
					item-value="id"
					v-model="idSubsidiary"
					hide-details
					single-line
					bottom
					@input="loadData"
					>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout d-flex>
			<v-layout row wrap ml-2>
				<v-flex md12 mt-1 pa-0 class="border-right">
					<v-menu 
					lazy
					v-model="menuStart"
					transition="scale-transition"
					offset-y
					full-width
					:nudge-left="40"
					class="menu-date-picker"
					max-width="290px">

					<v-text-field
					slot="activator"
					label="Picker in menu"
					v-model="dateStart"
					:disabled="!dateStart"
					prepend-icon="event"
					:append-icon="arrowIconStart"
					single-line
					hide-details
					readonly>
					</v-text-field>
					<v-date-picker
						v-model="dateStart"
						no-title
						scrollable
						@input="loadData"
						>
					</v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
				<v-flex md-6 pa-0 md-2>
					<v-menu
          		lazy
							v-model="menuEnd"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker"
							max-width="290px">
          	<v-text-field
							slot="activator"
							label="Picker in menu"
							:append-icon="arrowIconEnd"
							v-model="dateEnd"
							single-line
							hide-details
							readonly
          	></v-text-field>
         	 	<v-date-picker
            	no-title
							v-model="dateEnd"
            	scrollable
							@input="loadData"
						>
          	</v-date-picker>
        	</v-menu>
				</v-flex>
			<v-flex xs4 md12 text-xs-right>
				<section class="filters-by-time">
					<v-btn v-for="filter in filters"
						@click="onDateFilter(filter)"
						:class="{ 'activeBtn': filter.id === value }"
						:key="filter.id"
						:disabled="loading">
						{{filter.label}}
					</v-btn>
				</section>
			</v-flex>
			<v-flex xs12 md2>
				<v-btn
					type="button"
					class="btn-action btn-success white--text"
					@click="customBtn"
				>
					<v-icon>print</v-icon>
					Imprimir Reporte
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap mt-3>
			<v-flex xs12>
				<v-tabs class="checkin-tabs">
					<v-tabs-items>
						<table class="table-kitchen" border="0" cellspacing="0" cellpadding="0">
							<tr>
								<th class="border-right">Fecha</th>
								<th class="border-right">Reservas</th>
								<th class="border-right">In-House</th>
								<th class="border-right">Check-Out</th>
								<th >Cantidad de Huéspedes</th>
							</tr>
							<tr v-for="(item, index) in loadTable" :key="index" @actions="customBtn">
								<td class="border-right">{{item.date}}</td>
								<td class="border-right">{{item.reserve}}</td>
								<td class="border-right">{{item.inHouse}}</td>
								<td class="border-right">{{item.checkout}}</td>
								<td>{{item.total}}</td>
							</tr>
						</table>
					</v-tabs-items>
				</v-tabs>
			</v-flex>
		</v-layout>	
	</div>
</template>

<script>
import { format, subDays, addDays } from 'date-fns';
import helper from '@/shared/helper';

const helperMethods = helper.methods;

function customBtn() {
	this.printReports();
}

async function printReports() {
	const baseUrl = `${process.env.PMS_URL}/report/kitchen`;
	const dateStart = this.dateStart;
	const dateEnd = this.dateEnd;
	const idSubsidiary = this.idSubsidiary;
	const name = 'Reporte Cocina';
	const responseType = 'blob';
	const cardModel = { loadTable: [{}] };
	const response = await this.$http.post(`${baseUrl}?dateStart=${dateStart}&dateEnd=${dateEnd}&idSubsidiary=${idSubsidiary}`, cardModel, { responseType },
	);
	const blob = helperMethods.generateBlob(response.bodyBlob);
	helperMethods.showDownloadDialog(blob, name, 'pdf');
}

function onDateFilter(filter) {
	this.value = filter.id;
	if (this.value === 2) {
		this.dateEnd = format(addDays(new Date(), 7), 'YYYY-MM-DD');
	} else {
		this.dateEnd = format(addDays(new Date(), 0), 'YYYY-MM-DD');
	}
	this.loadData();
}

function created() {
	this.loadResources();
}

function arrowIconStart() {
	const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconEnd() {
	const arrow = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

async function loadData() {
	const params = {
		dateStart: this.dateStart,
		dateEnd: this.dateEnd,
		idSubsidiary: this.idSubsidiary,
	};
	const response = await this.$http.get(`${process.env.PMS_URL}/report-kitchen`, { params });
	this.loadTable = response.data.data;
}

async function loadResources() {
	const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = subsidiaries.data;
	this.idSubsidiary = this.subsidiaries[0].id;
}

function data() {
	return {
		value: 1,
		loadTable: [],
		idSubsidiary: '',
		subsidiaries: [],
		subsidiary: 0,
		loading: false,
		menuStart: false,
		dateStart: format(subDays(new Date(), 0), 'YYYY-MM-DD'),
		dateEnd: format(new Date(), 'YYYY-MM-DD'),
		menuEnd: false,
		date: format(new Date(), 'YYYY-MM-DD'),
		filters: [
			{
				id: 1, value: 1, label: 'Hoy',
			},
			{
				id: 2, value: 2, label: 'Semana',
			},
		],
	};
}

export default {
	name: 'kitchen',
	data,
	created,
	methods: {
		customBtn,
		printReports,
		onDateFilter,
		loadData,
		loadResources,
	},
	computed: {
		arrowIconStart,
		arrowIconEnd,
	},
};
</script>

<style lang="scss" scoped>
td {
	padding: 10px;
}

th {
	background-color: map-get($colors, bg-chart);
	color: map-get($colors, white-bond);
	font-size: 12px;
	padding: 10px;
}

tr:nth-child(odd) {
	background-color: rgba(241, 241, 241, 0.5);
}

tr:nth-child(even) {
	background-color: white;
} 

.table-kitchen {
	border: 1px solid map-get($colors, border-radio );
	width: 100%;
}

.border-right {
	border-right: 1px solid map-get($colors, e-bg-icon);
}

.header-booking-data {
	height: 31px;
	position: absolute;
	right: 20px;
	text-align: right;
	top: 50px;
	width: calc(100% - 230px);
}

.border-right {
	border-right: 1px solid map-get($colors, button-form );
}
</style>



// WEBPACK FOOTER //
// Kitchen.vue?0f3d8eea